import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  inlineFields: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  marginBottom: {
    marginBottom: theme.spacing(2),
  },
  richTextMarginBottom: {
    marginBottom: theme.spacing(2),
  },
  fullWidth: {
    width: '100%',
  },
}));
